import React from "react";
import { createGlobalStyle } from "styled-components";
import CV from "./components/CV";
import Footer from "./components/Footer";

// Define Global Styles
const GlobalStyle = createGlobalStyle`
  :root {
    --print-font-scale: 80%;
  }

  @media print {
    html {
      font-size: var(--print-font-scale);
    }
  }
`;

function App() {
  return (
    <>
      <GlobalStyle />
      <CV />
      <Footer />
    </>
  );
}

export default App;
